const mutations = {
  setTabData(state, { tabName, data }) {
    if (state.tabData[tabName]) {
      state.tabData[tabName] = { ...state.tabData[tabName], ...data };
    }
  },
  
  resetTabData(state, tabName) {
    if (state.tabData[tabName]) {
      state.tabData[tabName] = {
        pagination: {
          itemsPerPage: 10,
          page: 1,
        },
        totalItems: 0,
        searchBy: "customer_name",
        searchValue: "",
        status: null,
        showBy: null,
        dateRange: null,
        type: null,
      };
    }
  },
};

export default mutations; 